import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import TxnDownloadModalUI from './TxnDownloadModalUI.js'
import { getYearList } from '../../../components/common/GetYearList'

class TxnDownloadModalSF extends Component {
  constructor(props) {
    super(props)
    const { yearList, year, period } = getYearList()
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      year,
      yearList,
      yearError: null,
      period: 'Q1',
      periodError: null,
      format: 'pdf',
      formatError: null
    }
  }

  render() {
    
    let periodList = [
      {key: 'Q1', value: 'Q1'},
      {key: 'Q2', value: 'Q2'},
      {key: 'Q3', value: 'Q3'},
      {key: 'Q4', value: 'Q4'},
      {key: 'YEAR', value: 'Full year'},
    ]
    let formatList = [
      {key: 'pdf', value: 'PDF'},
      {key: 'excel', value: 'Excel'}
    ]
    return (
      <TxnDownloadModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        downloadMode={this.props.downloadMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        year={this.state.year}
        onYearChange={(event) => { this.setState({ year: event.target.value }) }}
        yearError={this.state.yearError}
        yearList={this.state.yearList}
        period={this.state.period}
        onPeriodChange={(event) => { this.setState({ period: event.target.value }) }}
        periodError={this.state.periodError}
        periodList={periodList}
        bankAccountNumber={this.props.bankAccountNumber}
        formatList={formatList}
        format={this.state.format}
        formatError={this.state.formatError}
        onFormatChange={(event) => {this.setState({format: event.target.value})}}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.get(this.props.context,
      `/api/accounts/${context.session.accountId}/bankAccounts/${this.props.bankAccountNumber}/bankStatements`,
      this.onSubmitCallback, null,
      {
        year: this.state.year,
        period: this.state.period,
        format: this.state.format
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      // link.setAttribute('download', 'bank_statement_template.pdf');
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(TxnDownloadModalSF)
